import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/700.css";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { ThemeProvider } from "./theme/ThemeContext";

/**
 * Provider order is load-bearing:
 *
 * - `BrowserRouter` outermost, because `App` renders `<Routes>` (which throws
 *   without a Router) and the pages use router hooks.
 * - `ThemeProvider` above `AuthProvider`, because `AuthProvider` reads the
 *   active auth mode via `useTheme()`.
 * - `AuthProvider` above `App`, because every page resolves the signed-in user
 *   through `useAuth()`.
 */
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
